// import { ENV } from "."
export{}

export const API_URL = process.env.REACT_APP_API_URL as string
export const API_STAGING_URL = process.env.REACT_APP_API_STAGING_URL as string
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL as string
export const SOCKET_STAGING_URL = process.env.REACT_APP_SOCKET_STAGING_URL as string
